export const SMARTPHONE_LESSONS_AR = [
  {
    id: 'smartphone-1',
    numero: 1,
    titre: "الأساسيات — الشاشة والتطبيقات",
    sousTitre: "للمبتدئين الكاملين",
    contexte: "هاتفك الذكي يبدو معقداً في البداية. إليك أساسيات الاستخدام اليومي.",
    explication: [
      "**تشغيل وإيقاف**: اضغط مطوّلاً على زر الطاقة (الجانب الأيمن عادةً). للإيقاف، اختر 'إيقاف التشغيل'.",
      "**الإيماءات الأساسية**: النقر للفتح، النقر المطوّل للخيارات، التمرير للتصفح، التكبير بإصبعين.",
      "**الرجوع**: زر السهم ← أو التمرير من الحافة اليسرى للرجوع لصفحة سابقة.",
      "**التطبيقات**: أيقونات على الشاشة الرئيسية. اضغط لفتح. اضغط مطوّلاً لتحريكها أو حذفها.",
      "**إغلاق التطبيقات**: اضغط زر المربعات (مدير التطبيقات) وأزَح التطبيقات غير المستخدمة.",
    ],
    question: "كيف تكبّر نصاً أو صورة على هاتفك؟",
    options: [
      { id: 'a', text: "بوضع إصبعين وتوسيعهما", correct: true },
      { id: 'b', text: "بالنقر ثلاث مرات", correct: false },
      { id: 'c', text: "لا يمكن التكبير على الهاتف", correct: false },
    ],
    explication_reponse: "التكبير بإصبعين يعمل في كل مكان — المتصفح، الصور، PDF، خرائط. ضع إصبعين على الشاشة وباعد بينهما للتكبير.",
  },
  {
    id: 'smartphone-2',
    numero: 2,
    titre: "المكالمات والرسائل",
    sousTitre: "التواصل بسهولة",
    contexte: "إجراء وتلقي مكالمات، إرسال رسائل نصية وWhatsApp. الأساسيات خطوة بخطوة.",
    explication: [
      "**إجراء مكالمة**: افتح تطبيق الهاتف (أيقونة سماعة)، ادخل الرقم أو اختر من جهات الاتصال، اضغط الأيقونة الخضراء.",
      "**تلقي مكالمة**: مرّر لليسار أو اضغط الأيقونة الخضراء. لرفضها، مرّر لليمين أو اضغط الأيقونة الحمراء.",
      "**الرسائل النصية SMS**: تطبيق الرسائل (أيقونة فقاعة حوار). اكتب، اختر جهة الاتصال، اضغط إرسال.",
      "**WhatsApp**: رسائل ومكالمات مجانية عبر الإنترنت. أنشئ حساباً برقم هاتفك — مجاني.",
      "**مكبّر الصوت**: أثناء المكالمة، اضغط 'مكبّر الصوت' لسماع أفضل بدون استخدام يديك.",
    ],
    question: "كيف ترفض مكالمة هاتفية واردة؟",
    options: [
      { id: 'a', text: "بالضغط على الأيقونة الحمراء أو التمرير", correct: true },
      { id: 'b', text: "بإيقاف تشغيل الهاتف", correct: false },
      { id: 'c', text: "لا يمكن رفض مكالمة واردة", correct: false },
    ],
    explication_reponse: "الأيقونة الحمراء لرفض المكالمة. على بعض الهواتف تمرير للأسفل أو اليمين. المكالمة المرفوضة تذهب للبريد الصوتي.",
  },
  {
    id: 'smartphone-3',
    numero: 3,
    titre: "تثبيت التطبيقات بأمان",
    sousTitre: "Play Store وApp Store فقط",
    contexte: "تريد تثبيت تطبيق CAF أو Ameli أو بنكك. كيف تفعل ذلك بأمان؟",
    explication: [
      "**Google Play Store** (Android) أو **App Store** (iPhone): هما المتجران الرسميان الوحيدان — ثبّت من هنا فقط.",
      "**البحث عن التطبيق**: اكتب اسمه في خانة البحث بالمتجر. انتبه للتطبيقات المشابهة للأصل.",
      "**تطبيق رسمي أم لا**: تحقق من اسم المطوّر — تطبيق CAF الرسمي مطوّره 'CAF — Caisse d'Allocations Familiales'.",
      "**التحديثات**: طبّق تحديثات التطبيقات بانتظام — تُصلح ثغرات الأمان.",
      "**لا تثبّت من روابط**: لا تثبّت أي تطبيق من رابط في SMS أو بريد إلكتروني — خطر الاحتيال.",
    ],
    question: "من أين يجب تثبيت تطبيق CAF على هاتفك؟",
    options: [
      { id: 'a', text: "من Google Play Store أو App Store فقط", correct: true },
      { id: 'b', text: "من موقع caf.fr مباشرة", correct: false },
      { id: 'c', text: "من رابط في رسالة SMS", correct: false },
    ],
    explication_reponse: "المتجران الرسميان هما المكان الوحيد الآمن لتثبيت التطبيقات. رابط في SMS لتثبيت تطبيق هو احتيال في الغالب.",
  },
  {
    id: 'smartphone-4',
    numero: 4,
    titre: "الأمان والخصوصية",
    sousTitre: "حماية هاتفك وبياناتك",
    contexte: "هاتفك يحتوي على معلوماتك الشخصية. كيف تحميه؟",
    explication: [
      "**رمز القفل**: استخدم PIN من 6 أرقام أو بصمة الإصبع لقفل هاتفك. ضروري في حالة الفقدان أو السرقة.",
      "**في حالة الفقدان**: iPhone: icloud.com/find. Android: myaccount.google.com — تتبّع موقعه أو امسح بياناته عن بُعد.",
      "**الأذونات**: عند تثبيت تطبيق، لا تمنح أذوناً غير ضرورية — تطبيق مصباح لا يحتاج صلاحية الكاميرا.",
      "**الشبكة WiFi**: لا تتصل بشبكات مجهولة. استخدم بيانات هاتفك للعمليات البنكية.",
      "**النسخ الاحتياطي**: فعّل النسخ الاحتياطي التلقائي (iCloud أو Google) لحفظ صورك ومعلوماتك.",
    ],
    question: "ضاع هاتفك. كيف تمسح بياناته عن بُعد على Android؟",
    options: [
      { id: 'a', text: "عبر myaccount.google.com من جهاز آخر", correct: true },
      { id: 'b', text: "لا يمكن مسح البيانات عن بُعد", correct: false },
      { id: 'c', text: "بالاتصال بمزوّد الخدمة فقط", correct: false },
    ],
    explication_reponse: "Google Find My Device على myaccount.google.com يتيح تتبع هاتفك، إصدار صوت، قفله، أو مسح كل بياناته عن بُعد — حماية ممتازة.",
  },
];
